import { ref, readonly } from 'vue'
import { http } from '@/lib/http'

interface AuthUser {
  id: number
  name: string
  email: string
  role?: string | null
  is_admin?: boolean
  permissions?: string[]
  tipo_usuario?: string
}

const user = ref<AuthUser | null>(null)
const loading = ref(false)

export function useAuth() {
  function setUser(value: AuthUser | null): void {
    user.value = value
  }

  async function fetchUser(): Promise<AuthUser | null> {
    loading.value = true
    try {
      const { data } = await http.get<{ user: AuthUser }>('/api/v1/auth/user')
      user.value = data.user
      return data.user
    } catch {
      user.value = null
      return null
    } finally {
      loading.value = false
    }
  }

  async function login(email: string, password: string): Promise<AuthUser> {
    await http.get('/sanctum/csrf-cookie')
    const { data } = await http.post<{ user: AuthUser }>('/api/v1/auth/login', {
      email,
      password,
    })
    user.value = data.user
    return data.user
  }

  async function logout(): Promise<void> {
    await http.post('/api/v1/auth/logout')
    user.value = null
  }

  function can(permission: string): boolean {
    return (user.value?.permissions ?? []).includes(permission)
  }

  return {
    user: readonly(user),
    loading: readonly(loading),
    setUser,
    fetchUser,
    login,
    logout,
    can,
  }
}
